import { Link } from "react-router-dom";
import styles from "../incomeGrid.module.css";
import dayjs from "dayjs";

const GridCards = ({ item, index }) => {
  return (
    <Link
      className={`${styles.ProspectCard}`}
      to={"/income/all-income/details/" + item.id}
      key={index}
    >
      <div className={`${styles.ProspectCardUnder}`}>
        <div className={`${styles.ProspectCardHeadSection}`}>
          <div className={`${styles.ProsIMGSec}`}>
            {item?.tenant_image !== "" ? (
              <img
                src={item?.tenant_image}
                className={`${styles.ProspectCardImg}`}
                alt=""
              />
            ) : (
              <p>{item?.tenant_initial}</p>
            )}
          </div>

          <div className={`${styles.HeadConSec}`}>
            <div className={`${styles.prospectNameActionSec}`}>
              <p className={`${styles.ProsUserName}`}>
                {item.tenant_name}{" "}
                {item?.no_of_tenant > 1 && "+" + (item?.no_of_tenant - 1)}
              </p>
            </div>
            {item.balance < 0 && (
              <div className={`${styles.InsideConCheck}`}>
                <img src="/static/img/RollCheck.svg" alt="" />
                <p>${item.formatted_balance} Over Paid</p>
              </div>
            )}
            {item.balance === 0 && (
              <div className={`${styles.InsideConCheck}`}>
                <img src="/static/img/RollCheck.svg" alt="" />
                <p>${item.formatted_balance} Balance</p>
              </div>
            )}
            {item.balance > 0 && (
              <div className={`${styles.InsideConCheck}`}>
                <img src="/static/img/RollPending.svg" alt="" />
                <p>${item.formatted_balance} Due</p>
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.ProspectCardBodySec}`}>
          <ul>
            <li>
              <p className={`${styles.Title}`}>
                <img src="/static/img/credit-icon.svg" alt="" />
                Last Payment :
              </p>
              <p className={`${styles.Content}`}>
                {item.last_payment_date
                  ? "$" + item.formatted_last_payment_amount
                  : " - "}
              </p>
            </li>
            <li>
              <p className={`${styles.Title}`}>
                <img src="/static/img/calendar.svg" alt="" />
                Payment Date :
              </p>
              <p className={`${styles.Content}`}>
                {item.last_payment_date ? dayjs(item.last_payment_date).format("MM/DD/YYYY") : " - "}
              </p>
            </li>
            <li>
              <p className={`${styles.Title}`}>
                <img src="/static/img/bill-icon.svg" alt="" />
                Monthly Rent :
              </p>
              <p className={`${styles.Content}`}>
                ${item.formatted_monthly_rent}
              </p>
            </li>
            <li>
              <p className={`${styles.Title}`}>
                <img src="/static/img/home.svg" alt="" />
                Property :
              </p>
              <p className={`${styles.Content}`}>{item.property_name}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}>
                <img src="/static/img/rooms.svg" alt="" />
                Unit :
              </p>
              <p className={`${styles.Content}`}>{item.apt_name}</p>
            </li>
          </ul>
        </div>
      </div>
    </Link>
  );
};

export default GridCards;
